module.exports = __webpack_public_path__ + "img/json.3b1c10d9.png";